import type { MembershipRow } from './types';

// Two rules, kept apart on purpose. `groupOf` is the Memberships page's rule, `listedInMemberships`
// the sidebar's (a port of the app's). They agree on every row a current server sends and differ on
// one edge: a row with no `state` and neither flag (an older server) is `lapsed` to the page and
// hidden from the sidebar. Do not merge them without changing one surface's behaviour knowingly.

export const MEMBERSHIP_GROUPS = ['current', 'upcoming', 'in_grace', 'lapsed'] as const;
export type MembershipGroup = (typeof MEMBERSHIP_GROUPS)[number];

/** `state` from the server; an older server sends none, so derive it from the flags it does send. */
export function groupOf(
  row: Pick<MembershipRow, 'state' | 'current' | 'in_grace'>,
): MembershipGroup | null {
  if (row.state) return row.state === 'ended' || row.state === 'past' ? null : row.state;
  if (row.current) return 'current';
  if (row.in_grace) return 'in_grace';
  return 'lapsed';
}

export type MineRow = { state?: string; current?: boolean; in_grace?: boolean };

/**
 * Mirrors the app's `listedOnProfile` (playpulse-app my_membership.dart): current, upcoming,
 * in grace and lapsed are listed; past and ended are not; an unknown or absent state falls back
 * to the `current` / `in_grace` flags (an older server).
 */
export function listedInMemberships(m: MineRow): boolean {
  switch (m.state) {
    case 'current':
    case 'upcoming':
    case 'in_grace':
    case 'lapsed':
      return true;
    case 'past':
    case 'ended':
      return false;
    default:
      return m.current === true || m.in_grace === true;
  }
}
